import { FunctionComponent } from "react";

import { useConfigTranslation } from "./ConfigField";

/** The in-app details step caps the people found per company at three. */
const MIN_PER_COMPANY = 1;
const MAX_PER_COMPANY = 3;

/**
 * How many people are enriched per matching company — the compact counterpart of
 * the "people per company" control in `DefineIcps`, which is what decides how
 * many credits a run of the list spends.
 */
export const PeoplePerCompanyStepper: FunctionComponent<{
	value: number;
	onChange: (value: number) => void;
}> = ({ value, onChange }) => {
	const ts = useConfigTranslation();

	const step = (delta: number) =>
		onChange(Math.min(MAX_PER_COMPANY, Math.max(MIN_PER_COMPANY, value + delta)));

	return (
		<div className="flex items-center gap-3">
			<div className="min-w-0 flex-1">
				<div className="label-styles">{ts("peoplePerCompany")}</div>
				<div className="text-xs text-text-meta">{ts("peoplePerCompanyHint")}</div>
			</div>
			<div className="flex flex-shrink-0 items-center gap-2">
				<button
					className="flex h-7 w-7 cursor-pointer items-center justify-center rounded border border-gray-200 bg-white text-base text-text-meta transition-colors duration-200 hover:border-brand-light hover:text-brand-light"
					data-test="onboarding-people-per-company-decrement"
					type="button"
					onClick={() => step(-1)}
				>
					−
				</button>
				<div
					className="w-6 text-center text-sm font-semibold"
					data-test="onboarding-people-per-company-value"
				>
					{value}
				</div>
				<button
					className="flex h-7 w-7 cursor-pointer items-center justify-center rounded border border-gray-200 bg-white text-base text-text-meta transition-colors duration-200 hover:border-brand-light hover:text-brand-light"
					data-test="onboarding-people-per-company-increment"
					type="button"
					onClick={() => step(1)}
				>
					+
				</button>
			</div>
		</div>
	);
};
